import React from 'react';
import './MLOps.css';

const m_main = () => {
    return (
        <div className="m_main__wrap m_main__wrap4">
            <div className="m_main container">
                <p className="m_main--data">Data Science Global Summit’22</p>
                <h1 className="m_main--title">MLOps & Data Engineering</h1>
                <p className="m_main--desc">Focusing on the practice, management, workflows and dataops of data science</p>
            </div>
        </div>
    );
};

export default m_main;